import type {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';
import { validateSession } from 'src/actions/login';

const UNAUTHORIZED = 401;

/**
 * Wraps an RTK Query baseQuery so a 401 from a feature endpoint causes the
 * canonical authentication session to be checked. The feature response alone
 * must not log the user out because some APIs use 401 for access failures.
 */
export const withSessionExpiredHandler = (
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta> => {
  return async (args, api: BaseQueryApi, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === UNAUTHORIZED) {
      api.dispatch(validateSession() as unknown as ReturnType<typeof api.dispatch>);
    }

    return result;
  };
};
